import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { tr as t } from "@/lib/i18n";

const shouldShow = () => window.innerWidth < 768 && !sessionStorage.getItem("splash_seen");

export default function Splash() {
  const [show, setShow] = useState(shouldShow);
  useEffect(() => {
    if (!show) return undefined;
    sessionStorage.setItem("splash_seen", "1");
    const tm = setTimeout(() => setShow(false), 1800);
    return () => clearTimeout(tm);
  }, [show]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div key="splash" data-testid="splash-screen" onClick={() => setShow(false)} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[100] bg-gradient-to-b from-brand-light via-brand to-brand-dark flex flex-col items-center justify-center text-white">
          <motion.div initial={{ scale: 0.4, opacity: 0, rotate: -20 }} animate={{ scale: 1, opacity: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 160, damping: 14 }}
            className="relative">
            <motion.span className="absolute -inset-4 rounded-full border-4 border-white/30" animate={{ scale: [1, 1.25], opacity: [0.8, 0] }} transition={{ duration: 1.2, repeat: Infinity }} />
            <img src="/img/logo.png" alt="شعار الشركة" className="w-40 h-40 rounded-full bg-white p-1.5 object-contain shadow-2xl" />
          </motion.div>
          <motion.h1 initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.45 }} className="text-3xl font-black mt-8">{t("المحيط الأطلسي")}</motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7 }} className="text-white/75 mt-1">{t("لنقل البضائع والمعدات")}</motion.p>
          <motion.div initial={{ width: 0 }} animate={{ width: 140 }} transition={{ delay: 0.5, duration: 1.1 }} className="h-1 rounded-full bg-white/80 mt-8" />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
